







































































































































































































import {
  DrivewealthAccountSummary,
  FetchState,
  FundType,
  GenericBarChartDataPoint,
  GenericChartValueType,
  GenericGraphPoint,
  InstrumentDetail,
  InstrumentPerformanceData,
  InstrumentPerformanceGraphTimePeriod,
  InstrumentStatus
} from "@/shared/types";
import { Component, Prop, Vue } from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import InvesmentPerformanceDisclosureCopy from "@/shared/components/investments/drivewealth/InvesmentPerformanceDisclosureCopy.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import GenericLineChart from "@/shared/components/charts/GenericLineChart.vue";
import GenericBarChart from "@/shared/components/charts/GenericBarChart.vue";
import EquityPerformanceSection from "@/shared/components/investments/drivewealth/EquityPerformanceSection.vue";
import EtfPerformanceSection from "@/shared/components/investments/drivewealth/EtfPerformanceSection.vue";
import InstrumentPerformanceMultiColumnBarChart from "@/shared/components/charts/InstrumentPerformanceMultiColumnBarChart.vue";
import { formatCurrency } from "@/shared/currency";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useInstrumentPerformanceDataStore } from "@/shared/store/instrumentPerformanceData";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useUserStore } from "@/shared/store/user";
import * as RouteNames from "@/employee/route-names";
import _ from "lodash";
import moment from "moment";
import * as SharedRoutes from "@/shared/route-names";
import { RawLocation } from "vue-router";

interface PriceGraphSelectOption {
  text: string;
  value: string;
}

@Component({
  computed: {
    SharedRoutes () {
      return SharedRoutes;
    },
    FetchState () {
      return FetchState;
    },
    GenericChartValueType () {
      return GenericChartValueType;
    }
  },
  components: {
    GenericLoadingSpinner,
    GenericLineChart,
    DrivewealthNavigation,
    AccountTypeSubheader,
    GenericBarChart,
    EquityPerformanceSection,
    EtfPerformanceSection,
    InstrumentPerformanceMultiColumnBarChart,
    InvesmentPerformanceDisclosureCopy
  }
})
export default class InstrumentPerformanceView extends Vue {
  @Prop({ required: false }) username: string;
  @Prop({ required: false }) partnerId: number;
  @Prop() symbol: string;
  @Prop() accountId: number;
  @Prop() isMutualFund: boolean;

  instrumentPerformanceDataStore = useInstrumentPerformanceDataStore();
  drivewealthStore = useDrivewealthStore();
  featureFlagStore = useFeatureFlagStore();
  userStore = useUserStore();

  moment = moment;
  formatCurrency = formatCurrency;
  RouteNames = RouteNames;

  dateNow = moment().format("YYYY-MM-DD");
  dateTomorrow = moment().add(1, "days").format("YYYY-MM-DD");
  date1WeekBefore = moment().add(-1, "weeks").format("YYYY-MM-DD");
  selectedGraphTimePeriod = InstrumentPerformanceGraphTimePeriod.Weeks1;
  selectedDateStart = this.dateNow;

  created (): void {
    this.selectedDateStart = this.isMutualFund ? this.date1WeekBefore : this.selectedDateStart;
    this.instrumentPerformanceDataStore.getInstrumentPerformanceData({
      username: this.username, partnerId: this.partnerId, stockSymbol: this.symbol});
    this.instrumentPerformanceDataStore.getInstrumentPerformanceGraphData({
      username: this.username, partnerId: this.partnerId,
      stockSymbol: this.symbol, dateStart: this.selectedDateStart, dateEnd: this.endDateForCurrentSelectedOption
    });
    this.drivewealthStore.getAccountSummaryV2({
      username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId
    });
    this.drivewealthStore.loadInstrumentData(this.symbol, this.accountId,
        { username: this.username, partnerId: this.partnerId });
  }

  get oneWeekPrior (): string {
    return moment().add(-1, "weeks").format("YYYY-MM-DD");
  }

  get oneMonthPrior (): string {
    return moment().add(-1, "months").format("YYYY-MM-DD");
  }

  get oneYearPrior (): string {
    return moment().add(-1, "years").format("YYYY-MM-DD");
  }

  get twoYearsPrior (): string {
    return moment().add(-2, "years").format("YYYY-MM-DD");
  }

  get threeYearsPrior (): string {
    return moment().add(-3, "years").format("YYYY-MM-DD");
  }

  get fiveYearsPrior (): string {
    return moment().add(-5, "years").format("YYYY-MM-DD");
  }

  get graphTimePeriodOptions (): PriceGraphSelectOption[] {
    return [
      {
        text: "1 D",
        value: this.dateNow
      },
      {
        text: "1 W",
        value: this.oneWeekPrior

      },
      {
        text: "1 M",
        value: this.oneMonthPrior
      },
      {
        text: "1 Y",
        value: this.oneYearPrior

      },
      {
        text: "2 Y",
        value: this.twoYearsPrior
      },
      {
        text: "3 Y",
        value: this.threeYearsPrior
      },
      {
        text: "5 Y",
        value: this.fiveYearsPrior
      },
    ];
  }

  get formattedDateNow (): string {
    return moment().format("MM/DD/YYYY");
  }

  get oneDayStartDateSelected (): boolean {
    return this.selectedDateStart === this.dateNow;
  }

  get endDateForCurrentSelectedOption (): string {
    return this.oneDayStartDateSelected ? this.dateTomorrow : this.dateNow;
  }

  get enforceMaxWidthContainer (): boolean {
    return this.featureFlagStore.flags.bend34224AddMaxWidthForFundPerformanceView;
  }

  get useOneDayPerformanceMetrics (): boolean {
    return this.oneDayStartDateSelected &&
        this.featureFlagStore.flags.bend29026UseFiveMinuteIncrementsForPerformanceDataGraph;
  }

  get graphDateFormat (): string {
    switch (this.selectedGraphTimePeriod) {
      case InstrumentPerformanceGraphTimePeriod.Days1:
        return "h:mm a";
      case InstrumentPerformanceGraphTimePeriod.Weeks1:
        return "E MM/dd";
      case InstrumentPerformanceGraphTimePeriod.Months1:
        return "MM/dd/yyyy";
      case InstrumentPerformanceGraphTimePeriod.Years1:
      case InstrumentPerformanceGraphTimePeriod.Years2:
      case InstrumentPerformanceGraphTimePeriod.Years3:
      case InstrumentPerformanceGraphTimePeriod.Years5:
        return "MMM yyyy";
      default:
        return "MM/dd/yyyy";
    }
  }

  openInstrumentUrl (): void {
    this.drivewealthStore.openInstrumentDetailFundResearchUrl({ stockSymbol: this.symbol, fallbackUrl: this.instrumentDetail.website });
  }

  get graphPointsLoaded (): boolean {
    return this.instrumentPerformanceDataStore.fundPerformanceGraphLoaded({
      stockSymbol: this.symbol,
      dateStart: this.selectedDateStart, dateEnd: this.endDateForCurrentSelectedOption
    });
  }

  get graphPointsForSelectedTimePeriod (): GenericGraphPoint[] {
    if (!this.graphPointsLoaded) {
      return [];
    }

    return this.instrumentPerformanceDataStore.fundPerformanceGraphPoints({
      stockSymbol: this.symbol,
      dateStart: this.selectedDateStart, dateEnd: this.endDateForCurrentSelectedOption
    });
  }

  get selectedTimePeriodClosePrice (): number {
    const firstDataPointInSelectedTimePeriod = _.head(this.graphPointsForSelectedTimePeriod);
    return firstDataPointInSelectedTimePeriod !== null ? firstDataPointInSelectedTimePeriod.value : 0;
  }

  get timePeriodPercentageChange (): number {
    const percentageChange = (100 *
        (this.instrumentDetail.currentPrice - this.selectedTimePeriodClosePrice) /
        ((this.selectedTimePeriodClosePrice)));
    return _.isNaN(percentageChange) ? 0 : percentageChange;
  }

  get timePeriodPriceChange (): number {
    return this.instrumentDetail.currentPrice - this.selectedTimePeriodClosePrice;
  }

  get timePeriodPriceChangeDisplayCopy (): string {
    return `(${this.timePeriodPercentageChange.toFixed(2)}%) ${this.timePeriodDisplayCopy}`;
  }

  get timePeriodDisplayCopy (): string {
    switch (this.selectedDateStart) {
      case this.dateNow:
        return "Today";
      case this.oneWeekPrior:
        return "Past 1 Week";
      case this.oneMonthPrior:
        return "Past 1 Month";
      case this.oneYearPrior:
        return "Past 1 Year";
      case this.twoYearsPrior:
        return "Past 2 Years";
      case this.threeYearsPrior:
        return "Past 3 Years";
      case this.fiveYearsPrior:
        return "Past 5 Years";
      default:
        return "Today";
    }
  }

  get trailingPerformancesBarChartData (): GenericBarChartDataPoint[] {
    return this.instrumentPerformanceDataStore.trailingPerformancesBarChartData(this.symbol);
  }

  get etfBarChartData () {
    return this.instrumentPerformanceDataStore.etfBarChartData(this.symbol);
  }

  updateGraphTimePeriod (startDate: string): void {
    this.selectedDateStart = startDate;
    this.instrumentPerformanceDataStore.getInstrumentPerformanceGraphData({
      username: this.username, partnerId: this.partnerId,
      dateStart: this.selectedDateStart,
      stockSymbol: this.symbol, dateEnd: this.endDateForCurrentSelectedOption
    });
  }

  get isLoaded (): boolean {
    return this.instrumentPerformanceDataStore.instrumentPerformanceLoaded(this.symbol);
  }

  get accountSummaryV2 (): DrivewealthAccountSummary {
    return this.drivewealthStore.accountSummaryById(this.accountId);
  }

  get hasAccount (): boolean {
    return this.accountId !== undefined;
  }

  routeParams (symbol: string): { symbol: string, accountId?: string, partnerId?: string } {
    if (this.accountId) {
      return { symbol, accountId: `${this.accountId}`, partnerId: `${this.partnerId}` };
    }

    return { symbol, partnerId: `${this.partnerId}` };
  }

  navigateBack (): void {
    const fallbackRoute: RawLocation = this.hasAccount ? {
      name: SharedRoutes.DrivewealthAvailableInvestmentsV2,
      params: this.routeParams(this.symbol),
      query: { username: this.username }
    } : {
      name: RouteNames.InvestmentAccountInfo,
      query: { username: this.username }
    };

    window.history.length > 1 ?
        this.$router.go(-1) : this.$router.push(fallbackRoute);
  }

  isPositiveNumber (value: number): boolean {
    return value > 0;
  }

  isNegativeNumber (value: number): boolean {
    return value < 0;
  }

  get isEmployerPortal (): boolean {
    return this.userStore.isEmployerPortal;
  }

  get instrumentDetail (): InstrumentDetail {
    return this.drivewealthStore.instrumentDetailBySymbol(this.symbol);
  }

  get canBuyThisInstrument (): boolean {
    return this.instrumentDetail && this.instrumentDetail.status === InstrumentStatus.Active;
  }

  get canSellThisInstrument (): boolean {
    if (!this.accountSummaryV2) {
      return false;
    }

    const holding = _.find(this.accountSummaryV2.holdings, x => x.stockSymbol === this.symbol);
    return !!holding;
  }

  get isLoading (): boolean {
    return this.instrumentPerformanceDataStore.instrumentPerformanceLoading(this.symbol);
  }

  get instrumentPerformanceData (): InstrumentPerformanceData {
    return this.instrumentPerformanceDataStore.instrumentPerformanceData(this.symbol);
  }

  get isEquityFund (): boolean {
    return this.instrumentPerformanceData.fundType === FundType.Equity;
  }

  get isEtfFund (): boolean {
    return this.instrumentPerformanceData.fundType === FundType.Etf;
  }

  get isEtfOrMutualFund (): boolean {
    return this.isEtfFund || this.isMutualFund;
  }

  hideButton (btnText: string): boolean {
    return btnText === "1 D" && this.isMutualFund;
  }
}
